import { Spin, SpinProps } from 'antd';
import { FC, ReactNode } from 'react';

interface ITcLoading extends SpinProps {
  spinning?: boolean;
  className?: string;
  children?: ReactNode;
}

const TcLoading: FC<ITcLoading> = ({ children, spinning = true, className, ...props }) => {
  return (
    <Spin className={className} spinning={spinning} {...props}>
      {children}
    </Spin>
  );
};

export default TcLoading;
